import {
  GET_CAMPAIGN_DETAIL_REQUEST,
  GET_CAMPAIGN_DETAIL_SUCCESS,
  GET_CAMPAIGN_DETAIL_FAILURE,
  SET_CAMPAIGN_KVKK_STATE,
  GET_CAMPAIGN_RESULT_REQUEST,
  GET_CAMPAIGN_RESULT_SUCCESS,
  GET_CAMPAIGN_RESULT_FAILURE,
  GET_USER_CAMPAIGN_RESULT_REQUEST,
  GET_USER_CAMPAIGN_RESULT_SUCCESS,
  GET_USER_CAMPAIGN_RESULT_FAILURE,
  GET_CAMPAIGN_PRIZE_REQUEST,
  GET_CAMPAIGN_PRIZE_SUCCESS,
  GET_CAMPAIGN_PRIZE_FAILURE,
} from 'Store/constants';

const initialState = {
  data: {},
  isKVKKchecked: false,
  isLoading: null,
  error: null,
  campaignResult: {
    data: {},
    isLoading: false,
    error: null
  },
  campaignUserResult: {
    data: {},
    isLoading: false,
    error: null,
  },
  campaignPrize: {
    data: {},
    isLoading: false,
    error: null,
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_DETAIL_REQUEST:
      return {
        ...state,
        data: {},
        isLoading: true,
        error: null
      };

    case GET_CAMPAIGN_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };

    case GET_CAMPAIGN_DETAIL_FAILURE:
      return {
        ...state,
        data: {},
        isLoading: false,
        error: action.payload
      };

    case SET_CAMPAIGN_KVKK_STATE:
      return {
        ...state,
        isKVKKchecked: action.isKVKKchecked
      };

    case GET_CAMPAIGN_RESULT_REQUEST:
      return {
        ...state,
        campaignResult: {
          ...state.campaignResult,
          isLoading: true,
        }
      };

    case GET_CAMPAIGN_RESULT_SUCCESS:
      return {
        ...state,
        campaignResult: {
          ...state.campaignResult,
          isLoading: false,
          data: action.payload,
        }
      };

    case GET_CAMPAIGN_RESULT_FAILURE:
      return {
        ...state,
        campaignResult: {
          ...state.campaignResult,
          isLoading: false,
          error: action.payload,
        }
      };

    case GET_USER_CAMPAIGN_RESULT_REQUEST:
      return {
        ...state,
        campaignUserResult: {
          ...state.campaignUserResult,
          isLoading: true,
        }
      };

    case GET_USER_CAMPAIGN_RESULT_SUCCESS:
      return {
        ...state,
        campaignUserResult: {
          ...state.campaignUserResult,
          isLoading: false,
          data: action.payload,
        }
      };

    case GET_USER_CAMPAIGN_RESULT_FAILURE:
      return {
        ...state,
        campaignUserResult: {
          ...state.campaignUserResult,
          isLoading: false,
          error: action.payload,
        }
      };

    case GET_CAMPAIGN_PRIZE_REQUEST:
      return {
        ...state,
        campaignPrize: {
          ...state.campaignPrize,
          isLoading: true,
        }
      };
  
    case GET_CAMPAIGN_PRIZE_SUCCESS:
      return {
        ...state,
        campaignPrize: {
          ...state.campaignPrize,
          isLoading: false,
          data: action.payload,
        }
      };
  
    case GET_CAMPAIGN_PRIZE_FAILURE:
      return {
        ...state,
        campaignPrize: {
          ...state.campaignPrize,
          isLoading: false,
          error: action.payload,
        }
      };

    default:
      return state;
  }
};
